import clsx from 'clsx';

import { Button } from '@commons/components/Button';
import Card from '@commons/components/Card';
import DrupalImage from '@commons/components/Image/Drupal';
import RichText from '@commons/components/RichText';
import Text from '@commons/components/Text';
import { Link } from '@commons/i18n/navigation';
import type {
  DrupalBlock,
  DrupalImage as DrupalImageType,
  DrupalLink,
} from '@commons/types/drupal';

// Type definition for the CardBlock component properties.

type Props = DrupalBlock<{
  title: string;
  upperTitle: string;
  body: string;
  image: DrupalImageType;
  link?: DrupalLink;
  hasBorder?: boolean;
}>;

/**
 * Card block component.
 */

const CardBlock = ({ content }: Props) => {
  const { image, body, link, title, upperTitle, hasBorder } = content;

  const classes = clsx('w-100', 'h-100', 'has-nested-button');

  const card = (
    <Card hasBorder={hasBorder} disabled={!link}>
      <Card.Content>
        {image && <DrupalImage {...image} />}
        {upperTitle && (
          <Text as="h6" level="label-lg" transform="uppercase" marginBottom="none">
            {upperTitle}
          </Text>
        )}
        <Card.Title>{title}</Card.Title>
        {body && <RichText marginTop="xxs" value={body} />}
      </Card.Content>
      {link && <Button variant="primary">{link.text}</Button>}
    </Card>
  );

  if (link)
    return (
      <Link href={link.url} className={classes}>
        {card}
      </Link>
    );

  return card;
};

export default CardBlock;
